import axios from '../axios'
import * as commonApi from './common'
import * as specialApi from './special'
import * as reportApi from '../../admin/api/report'
const loading = 'loading'

const pending = {}
/**
 * 获取token
 */
export const getToken = () => {
  if (pending.token) return pending.token
  pending.token = axios
    .get('/', {}, { responseType: 'text' })
    .then(({ data }) => {
      delete pending.token
      if (/name="?token"?\s*content="?([^>\s"]+)"?/.test(data)) return RegExp.$1
      return ''
    })
    .catch(() => {
      delete pending.token
    })
  return pending.token
}

/**
 * 登录
 */
export const signIn = data => axios.post('/jkd/home/login', data, { loading, silent: true }).then(({ data }) => data)

/**
 * 登出
 */
export const signOut = data => axios.get('/jkd/home/logout', data)

/**
 * 获取用户信息
 */
export const getUserInfo = data => {
  if (pending.userinfo) return pending.userinfo
  pending.userinfo = axios
    .post('/jkd/home/user', data, { timeout: 60 * 1000 })
    .then(({ data }) => data.data)
    .finally(() => {
      delete pending.userinfo
    })
  return pending.userinfo
}

export const updateExpireTime = () => axios.get('pc/expireTime')

export const common = commonApi
export const special = specialApi
export const report = reportApi

export default {
  common,
  special,
  report
}
